// extracted by mini-css-extract-plugin
export default {"image":"ProfilePicture_image__ySZ8T"};